import React from "react";
import ReactDOM from 'react-dom';
import PropTypes from "prop-types";
import { Button, Overlay, Popover } from "react-bootstrap";
import { injectIntl, FormattedMessage} from 'react-intl';
import DayPicker from "react-day-picker";
import classNames from "react-day-picker/lib/src/classNames";
import { formatDate } from "./GrafikenCommon";
import { TimePicker } from "./TimePicker";
import AlmigDropDown, {genAlmigDropdownItems, genAlmigDropdownTitle } from "../grundelemente/AlmigDropDown";
import { chartsDataSourceIndex } from "../model/Diagramme"

import "./Grafiken.css";

const getClockStringFromDate = (date) => {

	const pad = number => ((number < 10) ? ("0" + number.toString()) : number.toString())

	let newDate = new Date(date);
	const hours = pad(newDate.getHours());
	const minutes = pad(newDate.getMinutes());
	const seconds = pad(newDate.getSeconds());
	const timeString = hours + ":" + minutes + ":" + seconds;
	return timeString;
}
  
class ButtonSetDateAndTime extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.handleToggle = this.handleToggle.bind(this);
		this.handlePressOk = this.handlePressOk.bind(this);
		this.handleDayClick = this.handleDayClick.bind(this);

		const date = new Date(this.props.currentDateTimeMs);

		this.state = {
			show: false,
			selectedDay: date,
			clockTime: this.getMinAllowedClockTime(date)
		};

		this.myClassNames = {
			...classNames,
			/* DayPicker verwendet "new Date()" um "Heute" zu ermitteln.
			 * Das ist nicht in unserem Sinn, weil "Heute" im Browser ein
			 * anderes Datum sein kann als "Heute" auf der Steuerung.
			 */
			today: "do_not_highlight_today",
			/* Wenn man classNames selber definiert, müssen die folgenden
			 * Eigenschaften auch explizit gesetzt werden. Es sieht so aus,
			 * als ob man diesen Mechanismus vielleicht ein wenig anders
			 * verwenden sollte ...
			 */
			outside: "DayPicker-Day--outside",		/* Standard */
			selected: "DayPicker-Day--selected",	/* Standard */
			disabled: "DayPicker-Day--disabled"		/* Standard */
		};
	}

	isInRange(value) {
		let inRange = true;
		if(value < this.props.validRange[0]) {
			inRange = false;
		}
		if(value > this.props.validRange[1]) {
			inRange = false;
		}
		return inRange;
	}

	getStartOfSelectedDayTimestamp(date) {
		if(date === undefined || date === null) {
			return null;
		}
		else {
			date.setHours(0);
			date.setMinutes(0);
			date.setSeconds(0);
			return date.getTime();
		}
	}

	getEndOfSelectedDayTimestamp(date) {
		if(date === undefined || date === null) {
			return null;
		}
		else {
			date.setHours(23);
			date.setMinutes(59);
			date.setSeconds(59);
			return date.getTime();
		}
	}

	getMinAllowedTimestamp(date) {
		const timestampStartOfDay = this.getStartOfSelectedDayTimestamp(date);
		if(timestampStartOfDay === undefined || timestampStartOfDay === null) {
			return null;
		}
		else if(timestampStartOfDay <= this.props.validRange[0]) {
			return this.props.validRange[0];
		}
		else {
			return timestampStartOfDay;
		}
	}

	getMaxAllowedTimestamp(date) {
		const timestampEndOfDay = this.getEndOfSelectedDayTimestamp(date);
		if(timestampEndOfDay === undefined || timestampEndOfDay === null) {
			return null;
		}
		else if(timestampEndOfDay >= this.props.validRange[1]) {
			return this.props.validRange[1];
		}
		else {
			return timestampEndOfDay
		}
	}

	getMinAllowedClockTime(date) {
		const minDate = this.getMinAllowedTimestamp(date);
		if(minDate === undefined || minDate === null) {
			return "00:00:00";
		}
		else {
			return getClockStringFromDate(minDate);
		}
	}

	getMaxAllowedClockTime(date) {
		const maxDate = this.getMaxAllowedTimestamp(date);
		if(maxDate === undefined || maxDate === null) {
			return "23:59:59";
		}
		else {
			return getClockStringFromDate(maxDate);
		}
	}

	handleToggle() {
		const date = new Date(this.props.currentDateTimeMs);
		this.setState({
			show: !this.state.show,
			selectedDay: date,
			clockTime: this.getMinAllowedClockTime(date)
		});
	}

	handlePressOk() {
		let clockTime = this.state.clockTime;
		if(clockTime === undefined || clockTime === null) {
			return;
		}
		else {
			const hours = Number(clockTime.substr(0, 2));
			const minutes = Number(clockTime.substr(3, 2));
			const seconds = Number(clockTime.substr(6, 2));
			const secondsOfDay = (hours * 60 * 60) + (minutes * 60) + seconds;
			const millisOfDay = secondsOfDay * 1000;
			const timestampStartOfDay = this.getStartOfSelectedDayTimestamp(this.state.selectedDay);
			const newDateTime = timestampStartOfDay + millisOfDay;
			if(this.isInRange(newDateTime)) {
				this.props.acceptNewDate(newDateTime);
				this.setState({ show: false });
			}
		}
	}

	handleDayClick(day) {
		this.setState({
			selectedDay: day,
			clockTime: this.getMinAllowedClockTime(day)
		});
	}

	isDayDisabled(day) {
		// check, if day is in validRange
		const dayValidRangeMin = new Date(this.props.validRange[0]);
		const dayValidRangeMax = new Date(this.props.validRange[1]);
		if ((day >= dayValidRangeMin) && (day <= dayValidRangeMax)) {
			return false;
		}

		// disable all other days
		return true;
	}

	render() {
		return (
			<div className="Linechart">
				<Button
					bsClass="ButtonXTime"
					ref={button => {this.target = button;}}
					onClick={this.handleToggle}
				>
					{formatDate(this.props.currentDateTimeMs, this.props.intl)}
				</Button>

				<Overlay
					show={this.state.show}
					onHide={() => this.setState({ show: false })}
					placement={this.props.popupPlacement}
					target={() => ReactDOM.findDOMNode(this.target)}
					rootClose
				>
					<Popover
						id="ButtonSetDateAndTimePopover"
						position='relative'
					>
						<FormattedMessage id="Data Source"/><br/>
						<AlmigDropDown
							id="chartsDataSourceIndex"
							title={genAlmigDropdownTitle(chartsDataSourceIndex, this.props.dataSourceOfCharts)}
						>
							{ genAlmigDropdownItems(chartsDataSourceIndex, this.props.setDataSourceOfCharts) }
						</AlmigDropDown>
						<hr/>
						<DayPicker
							classNames={this.myClassNames}
							onDayClick={this.handleDayClick}
							selectedDays={this.state.selectedDay}
							disabledDays={(day) => (this.isDayDisabled(day))} // mag anscheinend keine member-functions: deshalb ein Wrapper um die eigentliche Funktion
						/>
						<TimePicker
							minTime={this.getMinAllowedClockTime(this.state.selectedDay)}
							maxTime={this.getMaxAllowedClockTime(this.state.selectedDay)}
							onChange={(str) => { this.setState({clockTime: str}); }}
							value={ this.state.clockTime }
						/>
						<hr/>
						<Button onClick={this.handlePressOk}>Ok{/*TODO: hier den text übersetzbar machen*/}</Button>
					</Popover>
				</Overlay>
			</div>
		);
	}
}

ButtonSetDateAndTime.propTypes = {
	validRange: PropTypes.array.isRequired,
	currentDateTimeMs: PropTypes.number.isRequired,
	acceptNewDate: PropTypes.func.isRequired,
	popupPlacement: PropTypes.string.isRequired,
	dataSourceOfCharts: PropTypes.number.isRequired,
	setDataSourceOfCharts: PropTypes.func.isRequired,
};

export default injectIntl(ButtonSetDateAndTime);